import { useParams } from "react-router-dom";
import PainDiscoveryDash from "../admin/PainDiscoveryDash";

/** Magic link: dashboard con embudo (mismo que /admin). */
export default function MagicFunnelDash() {
  const { token } = useParams<{ token: string }>();
  if (!token) return null;
  return <PainDiscoveryDash magicToken={token} />;
}
